<div class="ptl-data-table" [class.ptl-data-table--dark-header]="darkHeader">
  <div class="ptl-data-table__toolbar">
    <ng-content select="[table-toolbar]"></ng-content>
  </div>

  <div class="ptl-data-table__scroll">
    <div class="ptl-data-table__table" role="table">
      <div class="ptl-data-table__header" role="row">
        @for (col of columns; track col.key) {
          <div
            class="ptl-data-table__cell ptl-data-table__cell--head"
            role="columnheader"
            [style.text-align]="col.align || 'left'"
            [style.width]="col.width || null"
          >
            @if (col.sortable) {
              <button type="button" class="ptl-data-table__sort" (click)="onSort(col)">
                {{ col.label }}
                <ptl-icon
                  class="ptl-data-table__sort-icon"
                  [class.is-active]="sortKey === col.key"
                  [class.is-desc]="sortKey === col.key && sortDir === 'desc'"
                  [icon]="LucideArrowDown"
                  [size]="'xs'"
                ></ptl-icon>
              </button>
            } @else {
              {{ col.label }}
            }
          </div>
        }
      </div>

      <div class="ptl-data-table__body" role="rowgroup">
        @for (row of pagedRows; track trackRow($index, row)) {
          <div
            class="ptl-data-table__row"
            role="row"
            [class.ptl-data-table__row--clickable]="rowClickable"
            [attr.tabindex]="rowClickable ? 0 : null"
            (click)="onRowClick(row)"
            (keydown.enter)="onRowClick(row)"
          >
            @for (col of columns; track col.key) {
              <div class="ptl-data-table__cell" role="cell" [style.text-align]="col.align || 'left'" [style.width]="col.width || null">
                @if (cellTemplate(col.key); as tpl) {
                  <ng-container *ngTemplateOutlet="tpl; context: { $implicit: row, row: row }"></ng-container>
                } @else {
                  {{ row[col.key] }}
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>

  @if (pageSize) {
    <ptl-pagination-footer
      class="ptl-data-table__footer"
      [totalItems]="total"
      [pageSize]="pageSize"
      [currentPage]="page + 1"
      (pageChange)="onPage($event)"
    ></ptl-pagination-footer>
  }
</div>
